import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ServiceBasicInfoComponent = ({ selectServices, handleInnerFormChange}: any) => {

    return (
        <>
  <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="Key"
                          name="Key"
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'MapConfigurations.Key',
                              selectServices?.MapConfigurations,
                            );
                          }}
                          type="text"
                          value={selectServices?.MapConfigurations?.Key}
                        />
                      </div>
                  }
                  expandedPanel="BasicInfo"
                  headerTitle="BasicInfo"
                />
    </>
  )
}
export default ServiceBasicInfoComponent;
